import React from 'react';

import { Stack, Grid } from '@gogame/components';

import Filters from './filters';

const PrimaryFilters = () => (
  <Stack direction={'row'} spacing={2} style={{ margin: '16px' }}>
    <Grid item sx={{ width: 280 }}>
      <Filters.Networks />
    </Grid>
    <Grid item sx={{ width: 280 }}>
      <Filters.Applications />
    </Grid>
    <Grid item sx={{ width: 280 }}>
      <Filters.Managers />
    </Grid>
  </Stack>
);

export default PrimaryFilters;
